import { SelectOptionWithMetaPipe } from './select-option-with-meta.pipe';
import { SelectFieldTypeComponent } from './select-field-type.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { MatSelectModule } from '@angular/material/select';

import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { AvatarModule } from '@lockton-apps/shared/ui/lui';
import { LetDirective } from '@ngrx/component';
import { isEqual } from 'lodash';

@NgModule({
  declarations: [SelectFieldTypeComponent],
  imports: [
    AvatarModule,
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatPseudoCheckboxModule,
    MatIconModule,
    FormlySelectModule,
    SelectOptionWithMetaPipe,
    LetDirective,
    FormlyModule.forChild({
      types: [
        {
          name: 'select',
          component: SelectFieldTypeComponent,
          wrappers: ['mat-form-field', 'addons'],
          defaultOptions: {
            props: {
              placeholder: $localize`Please select`,
              compareWith: isEqual,
            },
          },
        },
        { name: 'enum', extends: 'select' },
      ],
    }),
  ],
})
export class SelectFieldTypeModule {}
